import React from 'react'
import Button from 'Components/Button'
import DualSpinner from 'Components/DualSpinner'
import PropTypes from 'prop-types'

const SubmitButton = ({
  variant,
  onClick,
  size,
  color,
  id,
  style,
  isSubmitting,
  isValid,
  topSpacing,
  bottomSpacing,
  text,
  className,
}) => {
  let buttonType = 'submit'
  if (onClick) buttonType = 'button' // in button mode
  return (
    <Button
      color={color}
      variant={variant}
      type={buttonType}
      onClick={onClick}
      size={size}
      id={id}
      style={style}
      className={`mt-${topSpacing * 2} mb-${bottomSpacing * 2} ${className}`}
      disabled={isSubmitting || !isValid}
    >
      {text}
      {isSubmitting && <DualSpinner />}
    </Button>
  )
}

SubmitButton.defaultProps = {
  size: 'medium',
  variant: 'contained',
  color: 'primary',
  style: {},
  id: '',
  onClick: undefined,
  topSpacing: 0,
  bottomSpacing: 2,
  className: '',
}

SubmitButton.propTypes = {
  color: PropTypes.string,
  size: PropTypes.string,
  variant: PropTypes.string,
  isSubmitting: PropTypes.bool.isRequired,
  isValid: PropTypes.bool.isRequired,
  text: PropTypes.string.isRequired,
  style: PropTypes.object,
  id: PropTypes.string,
  onClick: PropTypes.any,
  topSpacing: PropTypes.number, // used in styles
  bottomSpacing: PropTypes.number,
  className: PropTypes.string,
}

export default SubmitButton
